
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/articles/[...archive]",
      function () {
        return require("private-next-pages/category/articles/[...archive].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/articles/[...archive]"])
      });
    }
  